module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/past-projects/WWF My Kosong Plan@2x-2da5ca275ad6cf37a01f90679cc107f8.jpg";